
import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import { getImgPath } from '../store/JSTool';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';

export default function PageFooter(props) {

    const settingData = useSelector(state => state.settingData);

    function topTaped() {
        if (props.pageId) {
            JSTool.scrollToTop(props.pageId);
        }
    }

    return (
        <Stack sx={{
            width: 1,
            position: 'relative',
        }}>

            <Stack sx={{
                width: 1,
                justifyContent: 'center',
                bgcolor: '#FFA127',
                flexDirection: 'row',
                py: settingData.isMobile ? 1.5 : 3,
                position: 'relative',
            }}>
                <IconItem index={0} imgName='icon_Contact.png' title={settingData.langDic['lang6'].toUpperCase()} />
                <IconItem index={1} imgName='icon_Privacy.png' title={settingData.langDic['lang7'].toUpperCase()} />
                <IconItem index={2} imgName='terms.png' title={settingData.langDic['lang8'].toUpperCase()} />

                <Stack sx={{
                    display: settingData.isMobile ? 'none' : 'flex',
                    width: '1150px',
                    position: 'absolute',
                    bottom: 0,
                    alignItems: 'flex-end',
                }}>

                    <Box
                        onClick={topTaped}
                        component={'img'}
                        src={getImgPath('arrow_top.png')}
                        sx={{
                            height: '16px',
                            width: '50px',
                            objectFit: 'contain',
                            bgcolor: 'black',
                            p: 1,
                            mb: 2,
                            borderRadius: '20px',
                            cursor: 'pointer',
                            transitionDuration: '0.3s',
                            '&:hover': {
                                transform: 'scale(1.08)',
                            }

                        }} />

                </Stack>

            </Stack>

            {/* 版权 */}
            <Stack sx={{
                justifyContent: 'center',
                alignItems: 'center',
                bgcolor: 'black',
                width: 1,
                position: 'relative'
            }}>
                <Typography sx={{
                    color: 'white',
                    py: 1,
                    fontSize: settingData.isMobile ? 11 : 13,
                    fontWeight: 'bold'
                }}>
                    © A PLUS JAPAN Inc. All Rights Reserved
                </Typography>

                <Box
                    onClick={topTaped}
                    component={'img'}
                    src={getImgPath('arrow_top_black.png')}
                    sx={{
                        display: settingData.isMobile ? 'flex' : 'none',
                        height: '10px',
                        width: '36px',
                        objectFit: 'contain',
                        bgcolor: 'white',
                        zIndex: 10,
                        py: 0.5,
                        position: 'absolute',
                        borderRadius: '20px',
                        right: '15px',
                    }} />

            </Stack>
        </Stack>

    );
}

function IconItem(props) {
    const settingData = useSelector(state => state.settingData);

    const navigate = useNavigate();

    function tap() {
        if (props.index == 0) {
            navigate('/contact');

        } else if (props.index == 1) {
            navigate('/privacy');

        } else if (props.index == 2) {
            navigate('/policy');

        }
    }

    return (
        <Stack sx={{
            alignItems: 'center',
            width: settingData.isMobile ? '120px' : '280px',
        }}>

            <Box
                onClick={tap}
                component={'img'}
                src={getImgPath(props.imgName)}
                sx={{
                    height: settingData.isMobile ? '55px' : '85px',
                    cursor: 'pointer',
                    transitionDuration: '0.3s',
                    '&:hover': {
                        transform: !settingData.isMobile && 'scale(1.08)',
                    }
                }} />

            <Typography sx={{
                color: 'white',
                fontSize: settingData.isMobile ? 10 : 16,
                mt: settingData.isMobile ? 1 : 2,
                lineHeight: '20px',
                fontWeight: 'bold',
                whiteSpace: 'pre-line',
                textAlign: 'center',
                fontFamily: settingData.fontFM,
            }}>
                {props.title}
            </Typography>

        </Stack>
    );
}